import { OrderTermEnum } from '@modules/orders-module/enums/order-term.enum'

export const OrderTerms: OrderTermEnum[] = [
	OrderTermEnum.DAY,
	OrderTermEnum.DAY_PLUS,
	OrderTermEnum.GTC,
	OrderTermEnum.IOC,
	OrderTermEnum.OPG,
	OrderTermEnum.CLS,
]
